import React from 'react';
import useUserContext from '../context/user';

const DebugBanner = () => {
  const userContext = useUserContext();

  const val = [];
  if (userContext.data?.id) {
    val.push(`#${userContext.data.id}`);
  }
  if (userContext.data?.email) {
    val.push(userContext.data.email);
  }

  return (
    <div
      style={{
        top: 5,
        left: 5,
        fontSize: 12,
        padding: 5,
        background: 'red',
        zIndex: 1000,
        position: 'fixed',
        color: 'white',
      }}
    >
      DEBUG MODE {val.length > 0 && <>({val.join(', ')})</>}
    </div>
  );
};

export default DebugBanner;
